// ──────────────────────────────────────────────
// React hooks for DailyCallService.
// Use useSyncExternalStore for tear-free reads.
// ──────────────────────────────────────────────

import { useSyncExternalStore } from 'react';

import type { DailyCallService } from './DailyCallService';
import type { DailyCallState } from './types';
import { initialDailyCallState } from './types';

// ── Fallback snapshot (returned when service is null) ──

const IDLE_STATE: DailyCallState = initialDailyCallState();

const noop = () => () => {};

/**
 * Subscribe to DailyCallService state.
 * Returns a static idle state when service is null.
 */
export function useDailyCallState(service: DailyCallService | null): DailyCallState {
  return useSyncExternalStore(
    service ? (cb) => service.subscribe(cb) : noop,
    service ? () => service.getSnapshot() : () => IDLE_STATE,
  );
}
